var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoveUpBg00(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x3C_Layer_x3E_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3F4FF;}\r\n\t.st1{fill:#6FC6DD;}\r\n\t.st2{fill:#1F9DFC;}\r\n\t.st3{fill:#127E9A;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#739AF0;}\r\n\t.st6{fill:#163560;}\r\n\t.st7{fill:#76D5FF;}\r\n\t.st8{fill:#2E5A99;}\r\n\t.st9{fill:#18417C;}\r\n\t.st10{fill:#1C468A;}\r\n\t.st11{fill:#FFB27D;}\r\n\t.st12{fill:#FCA56B;}\r\n\t.st13{fill:#F5FEFF;}\r\n\t.st14{fill:#A5EAF2;}\r\n\t.st15{opacity:0.5;fill:#38A7C1;}\r\n\t.st16{opacity:0.7;}\r\n\t.st17{fill:#77A4E5;}\r\n\t.st18{fill:#9FC1F4;}\r\n\t.st19{fill:#36599E;}\r\n\t.st20{fill:#2B478B;}\r\n\t.st21{fill:#E8945B;}\r\n\t.st22{fill:#EBF3FA;}\r\n\t.st23{fill:#233862;}\r\n\t.st24{fill:#95C0F4;}\r\n\t.st25{fill:#B0D4FF;}\r\n\t.st26{fill:#006EB2;}\r\n\t.st27{fill:#ED975D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,1078.9c0.4-7.7-181.3-239.5,30.3-453.5C223.5,528.8,385,581.2,359.5,299 c-22.1-243.6,359.1-386.8,596-169.3c153,140.5,308-46.9,550.8,59.4c242.8,106.4,82.9,395.5,182.5,422.8 c196.3,53.7,293.7,289.8,137.3,464.4L97.6,1078.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M915.7,515.6c-1-2.1-2.2-4.3-3.4-6.4l3.4-1.9c1.3,2.2,2.4,4.4,3.5,6.6L915.7,515.6z M908.5,503 c-1.3-2-2.7-4-4.1-6l3.2-2.3c1.5,2,2.9,4.1,4.3,6.1L908.5,503z M518,546.3c-2.5,0.3-5,0.5-7.4,0.6l-0.2-3.9 c2.4-0.1,4.8-0.3,7.2-0.6L518,546.3z M525.4,545.4l-0.6-3.9c2.4-0.4,4.8-0.8,7.2-1.3l0.8,3.9C530.3,544.6,527.8,545,525.4,545.4z  M503.1,547.2c-2.5,0-5,0-7.5-0.1l0.2-3.9c2.4,0.1,4.8,0.2,7.3,0.1L503.1,547.2z M540,542.5l-0.9-3.8c2.3-0.6,4.7-1.2,7-1.9 l1.1,3.8C544.8,541.2,542.4,541.9,540,542.5z M488.2,546.5c-2.5-0.3-5-0.6-7.4-1l0.6-3.9c2.4,0.4,4.8,0.7,7.2,1L488.2,546.5z  M554.3,538.4l-1.2-3.7c2.3-0.7,4.6-1.6,6.9-2.4l1.4,3.7C559,536.8,556.6,537.6,554.3,538.4z M568.3,533.2l-1.5-3.6 c2.2-0.9,4.5-1.9,6.7-2.9l1.6,3.6C572.8,531.3,570.5,532.3,568.3,533.2z M473.4,544.1c-2.4-0.6-4.9-1.2-7.2-1.9l1.1-3.8 c2.3,0.7,4.6,1.3,7,1.8L473.4,544.1z M899.9,491.3c-1.5-1.9-3.1-3.7-4.8-5.5l2.9-2.6c1.7,1.8,3.3,3.7,4.9,5.7L899.9,491.3z  M581.8,527.1l-1.7-3.5c2.2-1,4.4-2.2,6.5-3.3l1.8,3.5C586.3,525,584,526.1,581.8,527.1z M459.1,539.9c-2.3-0.9-4.7-1.8-6.9-2.8 l1.6-3.6c2.2,1,4.4,1.9,6.7,2.7L459.1,539.9z M595,520.3l-1.9-3.4c2.1-1.2,4.2-2.4,6.3-3.7l2,3.4 C599.3,517.8,597.1,519.1,595,520.3z M890.2,480.6c-1.7-1.7-3.5-3.4-5.3-5l2.6-2.9c1.8,1.7,3.7,3.4,5.4,5.1L890.2,480.6z  M445.4,533.7c-2.2-1.2-4.4-2.5-6.5-3.8l2.1-3.3c2,1.3,4.1,2.5,6.2,3.7L445.4,533.7z M607.7,512.7l-2.1-3.3c2-1.3,4.1-2.6,6.1-4 l2.2,3.3C611.9,510,609.8,511.4,607.7,512.7z M620.1,504.5l-2.3-3.2c2-1.4,4-2.8,5.9-4.3l2.3,3.2 C624.1,501.6,622.1,503.1,620.1,504.5z M432.8,525.6c-2-1.5-4-3.1-5.8-4.8l2.6-2.9c1.8,1.6,3.7,3.1,5.6,4.6L432.8,525.6z  M879.4,470.8c-1.9-1.5-3.8-3-5.7-4.5l2.3-3.2c2,1.5,4,3,5.9,4.6L879.4,470.8z M632,495.7l-2.4-3.1l0.6-0.4c1.8-1.4,3.5-2.7,5.3-4 l2.4,3.1c-1.7,1.3-3.5,2.6-5.3,4L632,495.7z M867.7,462.1c-2-1.3-4.1-2.7-6.1-3.9l2-3.4c2.1,1.3,4.2,2.6,6.3,4L867.7,462.1z  M421.5,515.7c-1.7-1.8-3.4-3.7-5-5.6l3-2.5c1.5,1.8,3.1,3.7,4.8,5.4L421.5,515.7z M643.7,486.9l-2.3-3.2c2-1.4,4-2.9,6.1-4.3 l2.2,3.2C647.8,484,645.7,485.5,643.7,486.9z M855.2,454.6c-2.1-1.1-4.3-2.3-6.5-3.3l1.7-3.5c2.2,1.1,4.5,2.2,6.6,3.4L855.2,454.6 z M655.8,478.6l-2.2-3.3c2.1-1.4,4.2-2.7,6.2-4l2.1,3.3C659.9,475.9,657.9,477.2,655.8,478.6z M412,504.1c-1.4-2-2.8-4.2-4.1-6.3 l3.4-2c1.2,2.1,2.5,4.1,3.9,6.1L412,504.1z M668.2,470.8l-2-3.4c2.1-1.3,4.3-2.5,6.4-3.7l1.9,3.4 C672.4,468.3,670.3,469.5,668.2,470.8z M842.1,448.3c-2.2-0.9-4.5-1.8-6.8-2.7l1.4-3.7c2.3,0.9,4.7,1.8,6.9,2.7L842.1,448.3z  M680.9,463.6l-1.9-3.5c2.2-1.2,4.4-2.3,6.6-3.4l1.8,3.5C685.3,461.3,683.1,462.4,680.9,463.6z M828.5,443.3c-2.3-0.7-4.6-1.4-7-2 l1-3.8c2.4,0.6,4.8,1.3,7.2,2.1L828.5,443.3z M694,457l-1.7-3.6c2.2-1.1,4.5-2.1,6.8-3.1l1.6,3.6C698.5,454.9,696.2,455.9,694,457 z M404.4,491.1c-1.1-2.2-2.1-4.6-3-6.9l3.7-1.4c0.9,2.2,1.8,4.5,2.9,6.6L404.4,491.1z M814.5,439.6c-2.4-0.5-4.8-1-7.1-1.4 l0.6-3.9c2.4,0.4,4.9,0.9,7.3,1.4L814.5,439.6z M707.4,451.1l-1.5-3.6c2.3-0.9,4.6-1.8,6.9-2.7l1.4,3.7 C712,449.4,709.7,450.2,707.4,451.1z M800.1,437.2c-2.4-0.3-4.8-0.5-7.2-0.7l0.3-3.9c2.5,0.2,5,0.4,7.4,0.7L800.1,437.2z  M721.1,446.1l-1.2-3.7c2.4-0.8,4.7-1.5,7.1-2.2l1.1,3.8C725.8,444.6,723.4,445.4,721.1,446.1z M785.6,436.1 c-2.4-0.1-4.8-0.1-7.3-0.1l-0.1-3.9c2.5,0,5,0,7.4,0.1L785.6,436.1z M735.1,442l-1-3.8c2.4-0.6,4.8-1.2,7.2-1.7l0.8,3.8 C739.9,440.8,737.5,441.4,735.1,442z M771.1,436.3c-2.4,0.1-4.8,0.3-7.3,0.6l-0.4-3.9c2.5-0.2,5-0.4,7.4-0.6L771.1,436.3z  M749.4,438.9l-0.7-3.9c2.4-0.4,4.9-0.8,7.3-1.2l0.5,3.9C754.2,438.1,751.8,438.5,749.4,438.9z M398.9,477.1 c-0.7-2.4-1.4-4.8-1.9-7.3l3.8-0.9c0.5,2.4,1.1,4.7,1.8,7L398.9,477.1z M395.7,462.5c-0.1-0.9-0.3-1.8-0.4-2.7 c-0.2-1.6-0.3-3.2-0.5-4.7l3.9-0.3c0.1,1.5,0.3,3.1,0.4,4.6c0.1,0.9,0.2,1.7,0.4,2.6L395.7,462.5z M398.5,447.5l-3.9,0 c0-2.5,0-5,0.2-7.5l3.9,0.2C398.5,442.7,398.4,445.1,398.5,447.5z M399.3,433l-3.9-0.5c0.3-2.4,0.7-4.9,1.1-7.3l3.9,0.6l0,0.2 C399.9,428.3,399.6,430.7,399.3,433z M401.8,418.7l-3.8-0.9c0.5-2.4,1.2-4.9,1.8-7.2l3.8,1C403,414,402.4,416.4,401.8,418.7z  M536.3,398.8c-2.6,0.2-5.2,0.3-7.6,0.2l0.2-3.9c2.3,0.1,4.7,0,7.1-0.2L536.3,398.8z M543.8,397.7l-0.8-3.8 c2.3-0.5,4.6-1.1,6.9-1.9l1.3,3.7C548.7,396.4,546.2,397.1,543.8,397.7z M521.1,398.1c-2.6-0.6-5.1-1.4-7.4-2.4l1.6-3.6 c2.1,0.9,4.3,1.6,6.6,2.1L521.1,398.1z M558.2,392.8l-1.6-3.6c2.2-1,4.3-2.1,6.4-3.3l2,3.4C562.7,390.7,560.4,391.8,558.2,392.8z  M571.3,385.4l-2.3-3.2c2-1.4,3.9-2.9,5.7-4.4l2.6,3C575.3,382.4,573.3,383.9,571.3,385.4z M405.7,404.7l-3.7-1.2 c0.8-2.4,1.6-4.7,2.4-7l3.7,1.4C407.2,400.1,406.4,402.4,405.7,404.7z M507,391.8c-2.1-1.5-4-3.3-5.7-5.3l3-2.5 c1.5,1.8,3.2,3.4,5,4.7L507,391.8z M582.7,375.6l-2.8-2.7c1.7-1.7,3.3-3.5,4.7-5.4l3.1,2.4C586.2,371.8,584.5,373.7,582.7,375.6z  M410.7,391.1l-3.6-1.5c1-2.3,2-4.6,3.1-6.8l3.5,1.7C412.6,386.6,411.6,388.8,410.7,391.1z M497,380c-1.2-2.2-2.1-4.6-2.9-7.1 l3.8-1.2c0.7,2.3,1.6,4.5,2.7,6.5L497,380z M592.1,363.7l-3.3-2.1c1.3-2,2.4-4.1,3.5-6.2l3.5,1.7 C594.7,359.3,593.4,361.5,592.1,363.7z M417,377.9l-3.5-1.9c1.2-2.2,2.4-4.4,3.7-6.5l3.4,2C419.3,373.7,418.1,375.8,417,377.9z  M492.3,365.4c-0.1-0.7-0.2-1.4-0.3-2.1c-0.2-1.8-0.4-3.6-0.4-5.5l3.9-0.2c0.1,1.8,0.2,3.5,0.4,5.1c0.1,0.7,0.2,1.3,0.3,2 L492.3,365.4z M598.6,350.1l-3.7-1.3c0.8-2.2,1.4-4.6,1.9-6.9l3.8,0.8C600.2,345.2,599.5,347.7,598.6,350.1z M424.4,365.4 l-3.3-2.2c1.4-2.1,2.8-4.1,4.3-6.1l3.2,2.3C427.1,361.4,425.7,363.4,424.4,365.4z M495.6,350.5l-3.9-0.2c0.1-2.5,0.3-5,0.5-7.5 l3.9,0.4C495.8,345.6,495.7,348.1,495.6,350.5z M601.8,335.2l-3.9-0.3c0.2-2.3,0.3-4.7,0.2-7.1l3.9-0.1 C602.1,330.2,602,332.7,601.8,335.2z M433,353.7l-3.1-2.5c1.5-1.9,3.2-3.8,4.8-5.7l3,2.6C436.1,349.9,434.5,351.8,433,353.7z  M442.6,342.8l-2.8-2.7c1.7-1.8,3.5-3.5,5.3-5.3l2.7,2.9C446,339.3,444.3,341,442.6,342.8z M497.1,336.2l-3.9-0.7 c0.5-2.5,1-4.9,1.6-7.3l3.8,1C498.1,331.4,497.6,333.8,497.1,336.2z M597.2,320.8c-0.5-2.3-1.3-4.5-2.3-6.5l3.5-1.8 c1.1,2.3,2,4.8,2.6,7.3L597.2,320.8z M453.1,332.8l-2.6-3c1.9-1.6,3.8-3.2,5.7-4.8l2.4,3.1C456.8,329.6,455,331.2,453.1,332.8z  M500.8,322.3l-3.7-1.3c0.8-2.4,1.8-4.7,2.8-7l3.6,1.6C502.5,317.8,501.6,320,500.8,322.3z M591.1,308.6c-1.4-1.7-3.1-3.3-5-4.8 l2.4-3.1c2.1,1.6,4,3.4,5.6,5.4L591.1,308.6z M464.5,323.7l-2.3-3.2c2-1.5,4.1-2.9,6.1-4.2l2.2,3.3 C468.5,320.9,466.5,322.3,464.5,323.7z M476.7,315.7l-2-3.4c2.1-1.3,4.3-2.5,6.5-3.7l1.9,3.5C480.9,313.2,478.8,314.4,476.7,315.7 z M506.7,309.2l-3.4-1.9c1.1-1.9,2.2-3.8,3.4-5.7c-1.3,0.5-2.6,0.9-3.9,1.4l-1.4-3.7c2.3-0.9,4.7-1.7,7-2.5l1.2,3.7 c-0.7,0.2-1.3,0.4-2,0.7l2.7,1.8C509.1,305,507.9,307.1,506.7,309.2z M580.1,300.1c-2-1-4.2-2-6.5-2.8l1.3-3.7 c2.5,0.9,4.9,1.9,7,3L580.1,300.1z M489.5,308.7l-1.7-3.5c2.2-1.1,4.5-2.1,6.8-3.1l1.6,3.6C493.9,306.7,491.7,307.7,489.5,308.7z  M566.8,295.5c-2.3-0.5-4.6-0.9-7.1-1.2l0.5-3.9c2.6,0.3,5.1,0.7,7.5,1.2L566.8,295.5z M516.7,298.5l-0.8-2.8 c-0.4,0.5-0.8,1-1.2,1.5l-3.1-2.4c1.5-1.9,3.1-3.9,4.8-5.7l2.9,2.6c-0.8,0.9-1.6,1.8-2.3,2.7c2-0.5,3.9-1,5.9-1.4l0.8,3.8 C521.4,297.2,519,297.8,516.7,298.5z M552.5,293.8c-2.3-0.1-4.8-0.1-7.2,0l-0.2-3.9c2.5-0.1,5.1-0.1,7.5,0L552.5,293.8z  M530.9,295.3l-0.6-3.9c2.5-0.4,5-0.7,7.4-1l0.4,3.9C535.7,294.6,533.3,294.9,530.9,295.3z M524.3,286.4l-2.7-2.8 c1.8-1.7,3.6-3.4,5.5-5l2.5,3C527.8,283.2,526,284.8,524.3,286.4z M535.3,277.1l-2.4-3.1c1.9-1.5,4-2.9,6.1-4.3l2.2,3.3 C539.2,274.2,537.2,275.6,535.3,277.1z M547.4,269l-2-3.4c2.1-1.3,4.3-2.5,6.5-3.7l1.9,3.5C551.5,266.5,549.4,267.7,547.4,269z  M560.2,262l-1.7-3.5c2.2-1.1,4.5-2.1,6.8-3.1l1.6,3.6C564.5,259.9,562.3,261,560.2,262z M573.5,256.1l-1.5-3.7 c2.3-0.9,4.6-1.8,7-2.6l1.3,3.7C578.1,254.4,575.8,255.2,573.5,256.1z M587.3,251.2l-1.2-3.7c2.3-0.8,4.7-1.5,7.1-2.2l1.1,3.8 C591.9,249.7,589.6,250.5,587.3,251.2z M601.4,247.1l-1-3.8c2.4-0.6,4.8-1.2,7.2-1.8l0.9,3.8C606.1,245.9,603.7,246.5,601.4,247.1 z M615.6,243.8l-0.8-3.9c2.4-0.5,4.9-0.9,7.3-1.4l0.7,3.9C620.5,242.9,618.1,243.4,615.6,243.8z M637.3,240.5c0,0-2.7,0.2-7.2,0.8 l-0.5-3.9c4.7-0.6,7.4-0.9,7.4-0.9L637.3,240.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 673.5,
    className: "st1",
    width: 156.4,
    height: 401.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.3,
    y: 542.2,
    className: "st1",
    width: 156.4,
    height: 532.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.5,
    y: 400.6,
    className: "st1",
    width: 171.2,
    height: 674.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1196.8,
    y: 307.2,
    className: "st1",
    width: 156.4,
    height: 767.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1135.8,625.4 1464.5,466.2 1317.9,778.7 1293.1,636.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1060.2,518.8c-8-33,12.2-66.4,45.3-74.4c33-8,66.4,12.2,74.4,45.3c8,33-12.2,66.4-45.3,74.4 C1101.5,572.2,1068.2,551.9,1060.2,518.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1133.4,559.5c-14.6,3.5-29.6,1.2-42.4-6.6c-12.8-7.8-21.8-20.1-25.4-34.7c-3.5-14.6-1.2-29.6,6.6-42.4 c7.8-12.8,20.1-21.8,34.7-25.3c14.6-3.5,29.6-1.2,42.4,6.6c12.8,7.8,21.8,20.1,25.4,34.7c3.5,14.6,1.2,29.6-6.6,42.4 C1160.3,547,1148,556,1133.4,559.5z M1107.7,453.7c-28.3,6.9-45.7,35.5-38.8,63.7c6.9,28.3,35.5,45.7,63.7,38.8 c28.3-6.9,45.7-35.5,38.8-63.7C1164.6,464.2,1136,446.8,1107.7,453.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1131.5,519c-0.1-1.2-0.4-2.3-0.9-3.1c-0.5-0.9-1.1-1.6-2-2.3c-0.9-0.7-1.9-1.2-3.3-1.7 c-1.3-0.5-2.9-0.9-4.7-1.3c-3.2-0.7-6.1-1.5-8.7-2.3c-2.6-0.9-4.9-2-6.9-3.3c-2-1.3-3.5-2.9-4.8-4.9c-1.2-1.9-2-4.3-2.3-7.1 c-0.3-2.4-0.1-4.7,0.5-6.9c0.6-2.1,1.7-4,3.1-5.7c1.4-1.7,3.2-3.1,5.3-4.4c2.1-1.2,4.6-2.1,7.3-2.7l-1.1-9.2l7.4-0.9l1.1,9.4 c2.7,0,5.2,0.4,7.5,1.2c2.3,0.8,4.3,2,6,3.5c1.7,1.5,3.1,3.4,4.2,5.6c1.1,2.2,1.8,4.8,2.2,7.6l-13.4,1.6 c-0.4-3.5-1.5-5.9-3.2-7.5c-1.7-1.5-3.9-2.1-6.5-1.8c-1.4,0.2-2.6,0.5-3.5,1c-1,0.5-1.7,1.1-2.3,1.9c-0.6,0.8-1,1.6-1.2,2.6 c-0.2,1-0.2,2-0.1,3c0.1,1.1,0.4,2,0.8,2.8c0.4,0.8,1,1.6,1.9,2.2c0.8,0.6,1.9,1.2,3.3,1.7c1.3,0.5,3,1,4.9,1.4 c3.1,0.8,6,1.6,8.6,2.5c2.6,0.9,4.9,2,6.8,3.3c2,1.3,3.5,3,4.8,4.9c1.2,1.9,2,4.3,2.3,7.1c0.3,2.5,0.1,4.9-0.5,7 c-0.6,2.1-1.7,4-3.1,5.7c-1.4,1.7-3.2,3.1-5.4,4.3c-2.2,1.2-4.6,2.1-7.4,2.6l1,8.6l-7.4,0.9l-1-8.6c-2.6,0.1-5.2-0.2-7.7-0.8 c-2.5-0.6-4.8-1.6-6.8-3c-2.1-1.4-3.8-3.3-5.2-5.6c-1.4-2.3-2.3-5.2-2.8-8.7l13.4-1.6c0.2,2,0.7,3.7,1.5,5c0.7,1.3,1.6,2.3,2.7,3 c1.1,0.7,2.2,1.1,3.5,1.3c1.3,0.2,2.5,0.2,3.8,0c1.5-0.2,2.7-0.5,3.8-1c1.1-0.5,1.9-1.1,2.6-1.9c0.7-0.8,1.1-1.6,1.4-2.6 C1131.6,521.1,1131.7,520.1,1131.5,519z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6662 -0.7458 0.7458 0.6662 227.026 1191.0658)",
    className: "st3",
    cx: 1444.1,
    cy: 341.9,
    rx: 60,
    ry: 60
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1446.3,397.2c-14.6,0.6-28.5-4.6-39.2-14.5c-10.7-9.9-16.9-23.4-17.5-38c-0.6-14.6,4.6-28.5,14.5-39.2 c9.9-10.7,23.4-16.9,38-17.5c14.6-0.6,28.5,4.6,39.2,14.5c10.7,9.9,16.9,23.4,17.5,38c0.6,14.6-4.6,28.5-14.5,39.2 C1474.3,390.4,1460.9,396.7,1446.3,397.2z M1442.1,291.3c-28.3,1.1-50.4,25.1-49.3,53.4c1.1,28.3,25.1,50.4,53.4,49.3 c28.3-1.1,50.4-25.1,49.3-53.4C1494.4,312.3,1470.4,290.2,1442.1,291.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1452.3,358.2c0.1-1.2,0-2.2-0.3-3.2c-0.3-0.9-0.7-1.8-1.4-2.6c-0.7-0.8-1.6-1.5-2.8-2.3 c-1.1-0.7-2.6-1.4-4.2-2.2c-2.9-1.3-5.5-2.6-7.8-3.9c-2.3-1.3-4.3-2.8-5.9-4.4c-1.6-1.6-2.8-3.5-3.6-5.6 c-0.8-2.1-1.1-4.5-0.9-7.3c0.2-2.4,0.8-4.5,1.8-6.4c1-1.9,2.4-3.5,4-4.9c1.7-1.3,3.7-2.4,5.9-3.1c2.3-0.7,4.8-1.1,7.5-1.2l0.7-9 l7.3,0.6l-0.7,9.2c2.6,0.5,4.9,1.4,6.9,2.6c2,1.2,3.7,2.7,5.1,4.5c1.4,1.8,2.3,3.8,3,6.2c0.6,2.3,0.8,4.9,0.6,7.7l-13.1-1 c0.3-3.4-0.3-6-1.7-7.8c-1.4-1.8-3.3-2.8-5.8-3c-1.4-0.1-2.6,0-3.6,0.3c-1,0.3-1.9,0.8-2.6,1.4c-0.7,0.6-1.2,1.4-1.6,2.2 c-0.4,0.9-0.6,1.8-0.7,2.9c-0.1,1,0,2,0.2,2.9c0.2,0.9,0.7,1.7,1.4,2.5c0.7,0.8,1.6,1.5,2.8,2.3c1.2,0.7,2.7,1.5,4.4,2.3 c2.9,1.3,5.4,2.7,7.8,4c2.3,1.3,4.3,2.8,5.9,4.5c1.6,1.6,2.8,3.5,3.6,5.6c0.8,2.1,1.1,4.5,0.9,7.2c-0.2,2.5-0.8,4.7-1.8,6.6 c-1,1.9-2.4,3.5-4.1,4.8c-1.7,1.3-3.7,2.3-6,3c-2.3,0.7-4.8,1.1-7.6,1.1l-0.7,8.4l-7.2-0.6l0.7-8.4c-2.5-0.5-4.9-1.2-7.2-2.2 c-2.3-1-4.3-2.4-6-4.1c-1.7-1.7-3-3.9-3.9-6.4c-0.9-2.5-1.2-5.5-1-8.8l13.1,1c-0.2,2,0,3.7,0.4,5.1c0.5,1.4,1.1,2.5,2,3.4 c0.9,0.9,1.9,1.5,3.1,1.9c1.2,0.4,2.4,0.7,3.6,0.8c1.4,0.1,2.7,0,3.8-0.3c1.1-0.3,2-0.7,2.8-1.3c0.8-0.6,1.4-1.3,1.8-2.2 C1451.9,360.2,1452.2,359.2,1452.3,358.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1299.5,450.7c-0.4-22.8,17.8-41.7,40.6-42.1c22.8-0.4,41.7,17.8,42.1,40.6c0.4,22.8-17.8,41.7-40.6,42.1 C1318.8,491.7,1299.9,473.5,1299.5,450.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1341.6,488.1c-10.1,0.2-19.6-3.6-26.8-10.6c-7.2-7-11.3-16.4-11.5-26.5c-0.2-10.1,3.6-19.6,10.6-26.8 c7-7.2,16.4-11.3,26.5-11.5c10.1-0.2,19.6,3.6,26.8,10.6s11.3,16.4,11.5,26.5c0.2,10.1-3.6,19.6-10.6,26.8 C1361,483.8,1351.6,487.9,1341.6,488.1z M1340.3,415c-19.5,0.3-35.2,16.5-34.8,36.1c0.3,19.5,16.5,35.2,36.1,34.8 c19.5-0.3,35.2-16.5,34.8-36.1C1376,430.3,1359.8,414.6,1340.3,415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1346.3,461.3c0.1-0.8,0-1.5-0.1-2.2c-0.2-0.6-0.5-1.2-1-1.8c-0.5-0.6-1.1-1.1-1.9-1.6 c-0.8-0.5-1.7-1-2.9-1.6c-2-0.9-3.8-1.9-5.3-2.8c-1.6-1-2.9-2-4-3.2c-1.1-1.1-1.9-2.4-2.4-3.9c-0.5-1.4-0.7-3.1-0.5-5 c0.2-1.6,0.6-3.1,1.3-4.4c0.7-1.3,1.7-2.4,2.9-3.3c1.2-0.9,2.6-1.6,4.1-2.1c1.6-0.5,3.3-0.7,5.2-0.7l0.6-6.2l5,0.5l-0.6,6.3 c1.8,0.4,3.4,1.1,4.7,1.9c1.4,0.9,2.5,1.9,3.4,3.2c0.9,1.2,1.6,2.7,2,4.3c0.4,1.6,0.5,3.4,0.3,5.3l-9.1-0.9 c0.2-2.3-0.1-4.1-1-5.4c-0.9-1.3-2.2-2-4-2.1c-0.9-0.1-1.8,0-2.5,0.1c-0.7,0.2-1.3,0.5-1.8,0.9c-0.5,0.4-0.9,0.9-1.1,1.5 c-0.3,0.6-0.4,1.3-0.5,2c-0.1,0.7,0,1.4,0.1,2c0.2,0.6,0.5,1.2,0.9,1.7c0.5,0.5,1.1,1.1,1.9,1.6c0.8,0.5,1.8,1.1,3,1.7 c1.9,1,3.7,1.9,5.3,2.9c1.6,1,2.9,2,4,3.2c1.1,1.2,1.9,2.5,2.4,3.9c0.5,1.4,0.7,3.1,0.5,5c-0.2,1.7-0.6,3.2-1.4,4.5 c-0.7,1.3-1.7,2.4-2.9,3.3c-1.2,0.9-2.6,1.5-4.2,2c-1.6,0.4-3.3,0.7-5.2,0.6l-0.6,5.8l-5-0.5l0.6-5.8c-1.7-0.3-3.4-0.9-4.9-1.6 c-1.6-0.7-2.9-1.7-4.1-3c-1.1-1.2-2-2.7-2.6-4.4c-0.6-1.7-0.8-3.8-0.5-6.1l9,0.9c-0.1,1.4-0.1,2.5,0.2,3.5c0.3,1,0.7,1.7,1.3,2.4 c0.6,0.6,1.3,1.1,2.1,1.4c0.8,0.3,1.6,0.5,2.5,0.6c1,0.1,1.9,0.1,2.6-0.1c0.8-0.2,1.4-0.5,2-0.9c0.5-0.4,1-0.9,1.3-1.5 C1346,462.6,1346.2,462,1346.3,461.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9977 -6.780457e-02 6.780457e-02 0.9977 -16.9366 83.4698)",
    className: "st3",
    cx: 1221.1,
    cy: 291.2,
    rx: 101,
    ry: 101
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1250.4,379.7c-23.3,7.7-48.3,5.9-70.2-5.1c-22-11-38.3-30-46-53.3c-7.7-23.3-5.9-48.3,5.1-70.2 c11-22,30-38.3,53.3-46c23.3-7.7,48.3-5.9,70.2,5.1c22,11,38.3,30,46,53.3c7.7,23.3,5.9,48.3-5.1,70.2 C1292.7,355.6,1273.8,372,1250.4,379.7z M1194.3,210.3c-45.3,15-69.9,64-54.9,109.3c15,45.3,64,69.9,109.3,54.9 c45.3-15,69.9-64,54.9-109.3C1288.6,219.9,1239.6,195.3,1194.3,210.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1241.9,313.7c-0.4-2-1-3.6-1.9-5c-0.9-1.4-2-2.5-3.5-3.5c-1.5-1-3.3-1.7-5.5-2.4c-2.2-0.6-4.8-1.1-7.9-1.5 c-5.3-0.7-10.1-1.6-14.5-2.7c-4.4-1.1-8.3-2.5-11.6-4.4c-3.4-1.9-6.2-4.3-8.4-7.3c-2.3-3-3.9-6.8-4.8-11.3 c-0.8-4-0.8-7.7-0.1-11.3c0.7-3.5,2.2-6.8,4.3-9.8c2.1-3,4.8-5.6,8.2-7.8c3.3-2.3,7.2-4.1,11.6-5.4l-3.1-15l12-2.5l3.1,15.2 c4.4-0.3,8.6,0,12.4,1c3.9,1,7.3,2.6,10.3,4.9c3,2.2,5.6,5.1,7.7,8.6c2.1,3.5,3.6,7.5,4.6,12.2l-21.7,4.4 c-1.1-5.6-3.2-9.5-6.3-11.8c-3-2.3-6.7-3-10.8-2.1c-2.3,0.5-4.1,1.2-5.6,2.1c-1.5,1-2.7,2.1-3.5,3.4c-0.8,1.3-1.3,2.8-1.5,4.4 c-0.2,1.6-0.1,3.3,0.2,5c0.4,1.7,0.9,3.2,1.7,4.5c0.8,1.3,1.9,2.4,3.4,3.3c1.5,0.9,3.3,1.7,5.6,2.4c2.2,0.6,5,1.2,8.2,1.7 c5.2,0.8,10,1.8,14.4,2.9c4.4,1.1,8.3,2.6,11.6,4.5c3.4,1.9,6.2,4.4,8.4,7.3c2.3,3,3.8,6.7,4.8,11.3c0.8,4.1,0.9,7.9,0.1,11.5 c-0.8,3.6-2.2,6.8-4.3,9.7c-2.1,2.9-4.9,5.5-8.3,7.7c-3.4,2.2-7.3,4-11.7,5.3l2.8,13.9l-12,2.4l-2.8-13.8 c-4.3,0.4-8.5,0.3-12.6-0.3c-4.2-0.6-8-1.9-11.6-3.9c-3.5-2-6.6-4.8-9.3-8.5c-2.6-3.6-4.5-8.3-5.7-13.8l21.7-4.4 c0.7,3.3,1.7,6,3.1,8c1.4,2,3,3.5,4.8,4.6c1.8,1,3.8,1.6,5.9,1.7c2.1,0.1,4.2,0,6.2-0.4c2.4-0.5,4.4-1.2,6-2.2c1.7-1,3-2.1,4-3.4 c1-1.3,1.6-2.8,1.9-4.4C1242.3,317.1,1242.3,315.5,1241.9,313.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M822.7,263.5c-9.1,2.3-17.7,4.4-25.8,5.8c-26.2,4.5-46.5,0.8-55.2-34.2c-8.7-35,7.4-47.8,32.7-56.2 c7.8-2.6,16.5-4.7,25.5-7c19.4-4.8,40.9-2.7,58,2.9c16.8,5.5,29.4,14.4,31.6,23.3c2.5,10.2-4.4,23.9-16.7,36.4 C860.2,247.3,842.1,258.6,822.7,263.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "774.3,178.9 744.5,159.5 697.5,169.5 746.3,203.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "796.8,269 779.7,300.2 733.4,313.5 760.4,260.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M796.9,269.3c-26.2,4.5-46.5,0.8-55.2-34.2c-8.7-35,7.4-47.8,32.7-56.2L796.9,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M680.4,250.4c0,0,13.1-30.5,36-25.8c23.4,4.8,20.4,30,2.9,32.3C701.7,259.2,690.6,247.8,680.4,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M819.8,190.8c12.1-3,24.4,4.3,27.4,16.5c3,12.1-4.3,24.4-16.5,27.4c-12.1,3-24.4-4.3-27.4-16.5 C800.4,206.1,807.7,193.8,819.8,190.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M825.3,236.9c-10.8,0-20.7-7.3-23.4-18.3c-3.2-12.9,4.7-26,17.6-29.2c12.9-3.2,26,4.7,29.2,17.6 c1.6,6.3,0.6,12.7-2.7,18.3c-3.3,5.5-8.6,9.4-14.8,11C829.2,236.7,827.3,236.9,825.3,236.9z M825.3,191.7c-1.7,0-3.4,0.2-5.1,0.6 c-5.5,1.4-10.1,4.8-13,9.6c-2.9,4.8-3.7,10.5-2.4,16c2.8,11.3,14.3,18.2,25.6,15.4c5.5-1.4,10.1-4.8,13-9.6 c2.9-4.8,3.7-10.5,2.4-16C843.4,198.1,834.8,191.7,825.3,191.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M872.7,234.6l-14.9-59.8c16.8,5.5,29.4,14.4,31.6,23.3C892,208.4,885.1,222.1,872.7,234.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1549,562.8c0,0,45.7,47.4,47.9,65.2c2.2,17.8-21.9,45.7-21.9,45.7L1549,562.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1528.3,1053.8c0,0-1.6,25.1-6.5,25.5c-0.6,0-24.7,0-24.7,0l-30.7-0.2c0,0,0.2-7.4,9.2-8.9 c9-1.5,24-7.8,29.4-19.6C1510.9,1038,1528.3,1053.8,1528.3,1053.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1596.6,1053.9c0,0-1.6,25.1-6.5,25.5c-0.6,0-24.7,0-24.7,0l-30.7-0.2c0,0,0.2-7.4,9.2-8.9 c9-1.5,24-7.8,29.4-19.6C1579.2,1038.1,1596.6,1053.9,1596.6,1053.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1495,783.6c0,0,7.9,51.3,37.6,142.4s33.7,130.5,33.7,130.5l32.1-0.8c0,0,0.5-99.5-13.2-145.3 c-13.7-45.8-2.6-165-2.6-165L1495,783.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1479.4,747.9c0,0-1.3,77.3,11.9,172.2c13.2,94.9,8.5,135.2,8.5,135.2l32,1.1c0,0,19.3-94.9,14-142.4 c-5.4-47.5,26.6-162.9,26.6-162.9L1479.4,747.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1541.8,567.2l-17.1,11.1l-24.6-4.6c0.3-2,2-10.2,3.5-17.7c0.1-0.4,0.2-0.9,0.3-1.3 c1.3-6.4,2.4-11.8,2.4-11.8l23.1-10.1l8.6-3.8c0,0.1-0.7,7.1-0.8,8.1C1535.4,555,1541.8,567.2,1541.8,567.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1506.4,561.5c0.5-0.2,29.7-8.8,32.9-7.7c3.2,1.1,5,7.2,5,7.2l-47.8,10.7 C1496.5,571.7,1500.3,564.1,1506.4,561.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1584.7,757.7c-5,22.6-87.4,25.1-108.6,4.5c-2.4-2.3-2.5-13.2-1.6-27.9c1.8-28.6,7.7-71.7,7.9-93.7 c0.1-10.6,1.6-21.5,3.6-31.4c4.2-21,10.5-37.5,10.5-37.5s40.3-12.9,47.8-10.7C1580.6,571.7,1589.7,735.1,1584.7,757.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1474.5,734.3c1.8-28.6,7.7-71.7,7.9-93.7c0.1-10.6,1.6-21.5,3.6-31.4l24.2-4.2 C1510.2,605,1533.7,701.8,1474.5,734.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1487.7,694.4c0,0,1.6,3.9-1.8,6.6c-3.5,2.6-5.7,6.9-4.9,10.1c0.8,3.1,8.4,8.3,11,7.5c2.6-0.8,8-4.9,7.4-6.6 c-0.6-1.7,3.6-14.5-2.8-19.5C1490.2,687.5,1487.7,694.4,1487.7,694.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1515,565.9c0,0-23.6,4.4-42.5,32.1c-18.9,27.7-31.3,48.3-27.9,58.3c3.4,10,35,44.7,40.4,44.7 c5.4,0,14.2-3.9,14.8-12.8c0,0-22.2-33.4-17.8-38.4c1.9-2.1,28.9-24,32.8-14.1C1521.2,652.1,1515,565.9,1515,565.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1535.4,537.4c-5.1,8.6-23.9,15.9-31.8,18.6c0.1-0.4,0.2-0.9,0.3-1.3c1.3-6.4,2.4-11.8,2.4-11.8l23.1-10.1 C1534.4,532.7,1537.5,533.9,1535.4,537.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1497.5,541.5c0,0,37.1,11.7,44-11.5c6.9-23.2,16.3-37.3-7-45.7c-23.4-8.4-30.6-0.9-34.8,6.2 C1495.5,497.6,1488.1,537.8,1497.5,541.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1501.1,488.2c0,0,2.3,27,7.9,25.9c5.6-1.2,10.7-2,9.8,6.1c-0.8,8.1-8.6,17.5,8.6,19 c17.2,1.5,42.1-42.9,37.3-51.3C1551.2,463.6,1481.5,458.6,1501.1,488.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1321.4,1063.7v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.3,0-0.5,0.1-0.8,0.1h-184.3c-2.2,0-4.1-1.4-4.4-3.2c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2,0-0.4c0.3-1.8,2.2-3.2,4.4-3.2h184.3c0.3,0,0.5,0,0.8,0.1c0.3,0,0.6,0.1,0.8,0.2c0.9,0.3,1.6,0.8,2.1,1.4 C1321.1,1062.2,1321.4,1062.9,1321.4,1063.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1230.8,1077.1h-98.8c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2 v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h86.6 C1220.1,1065,1223.3,1072,1230.8,1077.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1296.8,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1289.7,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1281.2,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268.2,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254.4,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.3,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1213.5,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1195.8,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.6,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1312.3,
    y: 1059.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1317.7,1060v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1317.2,1059.9,1317.4,1059.9,1317.7,1060z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1320.6,1061.6v13.9c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1319.4,1060.4,1320.1,1060.9,1320.6,1061.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1301.6,1046.4v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.1,0.2-0.3,0.3-0.4,0.4c-0.5,0.4-1,0.7-1.7,1 c-0.3,0.1-0.5,0.2-0.8,0.2c-0.3,0-0.5,0.1-0.8,0.1h-184.3c-2.2,0-4.1-1.4-4.4-3.2c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2v-9.7 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0.3-1.8,2.2-3.2,4.4-3.2h184.3c0.1,0,0.2,0,0.4,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.1,0.4,0.2h0c0.1,0,0.2,0.1,0.3,0.1 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1 c0,0,0,0,0,0.1l0,0c0.1,0.1,0.1,0.1,0.2,0.2C1301.4,1045,1301.6,1045.7,1301.6,1046.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1211.1,1059.9h-98.8c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2 v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h86.6c0,0.1,0.1,0.3,0.1,0.4 C1200.6,1048.2,1203.8,1054.9,1211.1,1059.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1277.1,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1261.5,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234.7,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1213.6,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.8,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1176.1,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1283.9,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1288.3,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1292.6,
    y: 1042.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1298,1042.8v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1297.5,1042.7,1297.7,1042.7,1298,1042.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1300.9,1044.4v13.9c-0.5,0.6-1.2,1.1-2.1,1.4V1043C1299.6,1043.2,1300.4,1043.7,1300.9,1044.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1311.2,1029.7v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.3,0-0.5,0.1-0.8,0.1h-184.3c-0.7,0-1.4-0.2-2.1-0.4c-1.2-0.5-2.1-1.5-2.3-2.7c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0.3-1.8,2.2-3.2,4.4-3.2h184.3c0.3,0,0.5,0,0.8,0.1 c0.3,0,0.6,0.1,0.8,0.2c0.9,0.3,1.6,0.8,2.1,1.4C1310.9,1028.2,1311.2,1028.9,1311.2,1029.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1220.7,1043.1h-98.8c-0.7,0-1.3-0.2-1.8-0.4c-1.1-0.5-1.9-1.5-2.1-2.7c0-0.1,0-0.2,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8 h86.6c1.3,4.9,4.4,11.7,11.5,16.8C1220.3,1042.8,1220.5,1043,1220.7,1043.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1286.6,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279.6,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1271.1,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.2,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1223.1,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1203.3,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1185.7,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1293.4,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1297.9,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.2,
    y: 1025.9,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1307.5,1026v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1307,1025.9,1307.2,1025.9,1307.5,1026z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1310.4,1027.6v13.9c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1309.2,1026.4,1309.9,1026.9,1310.4,1027.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1315.6,1012.5v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.1,0.1-0.1,0.2-0.2,0.2c-0.4,0.4-0.8,0.7-1.3,0.9 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0.1-0.5,0.2-0.8,0.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0h-184.3c-2.2,0-4.1-1.4-4.4-3.2 c0-0.1,0-0.2,0-0.4v-10.1c0.1-1.8,1.8-3.3,3.9-3.5c0.2,0,0.4,0,0.5,0h184.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0 c0.3,0,0.6,0.1,0.8,0.2c0.9,0.3,1.6,0.8,2.1,1.4C1315.3,1011,1315.6,1011.7,1315.6,1012.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1225.1,1025.9h-98.8c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4v-10.1 c0.1-1.8,1.6-3.3,3.5-3.5c0.2,0,0.3,0,0.5,0h86.6c0,0,0,0,0,0C1214.3,1013.8,1217.6,1020.8,1225.1,1025.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1291.1,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1284,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1275.5,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1262.4,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.7,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1227.5,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1207.7,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.1,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1297.8,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.3,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1306.6,
    y: 1008.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1311.9,1008.8v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1311.4,1008.7,1311.7,1008.7,1311.9,1008.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1314.8,1010.4v13.9c-0.5,0.6-1.2,1.1-2.1,1.4V1009C1313.6,1009.2,1314.3,1009.7,1314.8,1010.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1302,995.3v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.1,0-0.2,0-0.3,0h0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0h-184.3c-2.4,0-4.3-1.6-4.5-3.6c0-0.1,0-0.1,0-0.2 v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0.2-1.6,1.6-2.9,3.3-3.3c0,0,0.1,0,0.1,0c0.3-0.1,0.6-0.1,1-0.1h184.3 c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0h0c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0.1,0.8,0.2c0.9,0.3,1.6,0.8,2.1,1.4 C1301.8,993.8,1302,994.5,1302,995.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1211.5,1008.7h-98.7c-2.1,0-3.9-1.6-4-3.6c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2 c0.2-1.6,1.4-2.9,3.1-3.3c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.7-0.1h86.6c0,0,0,0.1,0,0.1 C1200.8,996.7,1204.1,1003.6,1211.5,1008.7C1211.5,1008.7,1211.5,1008.7,1211.5,1008.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1277.5,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270.4,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1261.9,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.9,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.1,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1194.2,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1176.5,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1284.3,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1288.7,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1293,
    y: 991.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1298.4,991.6v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1297.8,991.5,1298.1,991.5,1298.4,991.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1301.3,993.2v13.9c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1300,992.1,1300.8,992.6,1301.3,993.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1301.6,978.2v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.1,0.2-0.3,0.3-0.4,0.4c-0.5,0.4-1,0.7-1.7,1 c-0.2,0.1-0.4,0.1-0.6,0.2h0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5,0.1-0.8,0.1h-184.3c-0.2,0-0.4,0-0.6,0 c-0.1,0-0.2,0-0.2,0c-1.9-0.3-3.4-1.6-3.6-3.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4 c0.3-1.8,2.2-3.2,4.4-3.2h184.3c0.1,0,0.2,0,0.4,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0 c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.1,0.4,0.2h0c0.6,0.3,1.1,0.6,1.5,1c0.1,0.1,0.1,0.1,0.2,0.2 C1301.4,976.7,1301.6,977.4,1301.6,978.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1211.1,991.7h-98.8c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0c-1.8-0.2-3.2-1.5-3.5-3.2c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h86.6 c0,0.1,0.1,0.3,0.1,0.4c1.4,5,4.6,11.7,11.8,16.7C1211,991.6,1211.1,991.6,1211.1,991.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1277.1,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1261.5,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234.7,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1213.6,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.8,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1176.1,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1283.9,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1288.3,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1292.6,
    y: 974.4,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1298,974.5v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1297.5,974.4,1297.7,974.5,1298,974.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1300.9,976.1V990c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1299.6,975,1300.4,975.5,1300.9,976.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1311.2,961.4v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.1-0.8,0.2 c-0.3,0-0.5,0.1-0.8,0.1h-184.3c-0.7,0-1.4-0.2-2.1-0.4c-1.2-0.5-2.1-1.5-2.3-2.7c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0.3-1.8,2.2-3.2,4.4-3.2h184.3c0.3,0,0.5,0,0.8,0.1 c0.3,0,0.6,0.1,0.8,0.2c0.9,0.3,1.6,0.8,2.1,1.4C1310.9,959.9,1311.2,960.6,1311.2,961.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1220.7,974.9h-98.8c-0.7,0-1.3-0.2-1.8-0.4c-1.1-0.5-1.9-1.5-2.1-2.7c0-0.1,0-0.2,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8 h86.6c1.3,4.9,4.4,11.7,11.5,16.8C1220.3,974.6,1220.5,974.7,1220.7,974.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1286.6,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279.6,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1271.1,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.2,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1223.1,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1203.3,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1185.7,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1293.4,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1297.9,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.2,
    y: 957.7,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1307.5,957.7v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1307,957.7,1307.2,957.7,1307.5,957.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1310.4,959.3v13.9c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1309.2,958.2,1309.9,958.7,1310.4,959.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1326.2,944.2v9.7c0,0.8-0.3,1.5-0.8,2.1l0,0c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.3-0.6,0.6-1,0.8 c-0.2,0.1-0.4,0.2-0.6,0.3c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.3,0-0.5,0.1-0.8,0.1h-184.3 c-2.2,0-4.1-1.4-4.4-3.2c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0.1-1.8,1.8-3.3,3.9-3.5 c0.2,0,0.3,0,0.5,0h184.3c0.3,0,0.5,0,0.8,0.1c0.3,0,0.6,0.1,0.8,0.2c0.7,0.2,1.4,0.7,1.9,1.2c0.1,0.1,0.1,0.1,0.2,0.2l0,0 C1326,942.7,1326.2,943.4,1326.2,944.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1235.7,957.7H1137c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2 v-9.7c0-0.1,0-0.1,0-0.2c0.1-1.8,1.6-3.3,3.5-3.5c0.2,0,0.3,0,0.5,0h86.6c0,0,0,0,0,0C1225,945.5,1228.2,952.5,1235.7,957.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1301.7,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1294.6,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1286.1,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1273.1,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1259.3,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1238.2,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1218.4,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200.7,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.5,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1312.9,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1317.2,
    y: 940.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1322.6,940.5v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1322,940.5,1322.3,940.5,1322.6,940.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1325.5,942.1V956c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1324.2,941,1325,941.5,1325.5,942.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1302,927v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.1,0-0.2,0-0.3,0h0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0h-184.3c-1.6,0-3-0.7-3.8-1.8 c-0.4-0.5-0.6-1.1-0.7-1.8c0-0.1,0-0.1,0-0.2V927c0-0.1,0-0.1,0-0.2c0.1-1.6,1.4-2.9,3.2-3.4c0.4-0.1,0.8-0.2,1.3-0.2h184.3 c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0.3,0,0.6,0.1,0.8,0.2c0.1,0,0.3,0.1,0.4,0.1h0c0.5,0.2,0.9,0.5,1.3,0.8 c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0.1,0.2,0.2,0.4,0.4C1301.8,925.5,1302,926.2,1302,927z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1211.5,940.5h-98.7c-1.4,0-2.6-0.7-3.3-1.7c-0.4-0.5-0.6-1.2-0.7-1.9c0-0.1,0-0.1,0-0.2V927 c0-0.1,0-0.1,0-0.2c0.1-1.7,1.4-3.1,3.2-3.5c0.3-0.1,0.5-0.1,0.8-0.1h86.6c0,0.1,0.1,0.3,0.1,0.4 C1200.9,928.7,1204.2,935.5,1211.5,940.5C1211.5,940.5,1211.5,940.5,1211.5,940.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1277.5,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270.4,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1261.9,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.9,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.1,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1194.2,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1176.5,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1284.3,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1288.7,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1293,
    y: 923.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1298.4,923.3v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1297.8,923.3,1298.1,923.3,1298.4,923.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1301.3,924.9v13.9c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1300,923.8,1300.8,924.3,1301.3,924.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1315.6,910.2v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.3,0-0.5,0.1-0.8,0.1h-184.3c-0.7,0-1.4-0.1-2-0.4c-1.3-0.6-2.3-1.7-2.5-3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2v-9.7 c0-0.1,0-0.1,0-0.2c0.1-1.8,1.8-3.3,3.9-3.5c0.2,0,0.3,0,0.5,0h184.3c0.3,0,0.5,0,0.8,0.1c0.3,0,0.6,0.1,0.8,0.2 c0.9,0.3,1.6,0.8,2.1,1.4C1315.3,908.7,1315.6,909.4,1315.6,910.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1225.1,923.7h-98.7c-0.6,0-1.2-0.1-1.8-0.4c-1.2-0.6-2.1-1.7-2.2-3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2 v-9.7c0-0.1,0-0.1,0-0.2c0.1-1.8,1.6-3.3,3.5-3.5c0.2,0,0.3,0,0.5,0h86.6c0,0,0,0,0,0c1.4,4.9,4.4,11.7,11.6,16.8 C1224.7,923.4,1224.9,923.5,1225.1,923.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1291.1,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1284,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1275.5,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1262.4,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.7,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1227.5,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1207.7,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.1,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1297.8,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.3,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1306.6,
    y: 906.5,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1311.9,906.5v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1311.4,906.5,1311.7,906.5,1311.9,906.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1314.8,908.1V922c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1313.6,907,1314.3,907.5,1314.8,908.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1321.4,893v9.7c0,0.8-0.3,1.5-0.8,2.1c-0.5,0.6-1.2,1.1-2.1,1.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0h-184.3c-2.4,0-4.3-1.6-4.5-3.6c0-0.1,0-0.1,0-0.2V893 c0-0.1,0-0.1,0-0.2c0.1-2,2.1-3.6,4.5-3.6h184.3c0.3,0,0.5,0,0.8,0.1c0.3,0,0.6,0.1,0.8,0.2c0.9,0.3,1.6,0.8,2.1,1.4 C1321.1,891.5,1321.4,892.3,1321.4,893z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1230.8,906.5h-98.7c-2.1,0-3.9-1.6-4-3.6c0-0.1,0-0.1,0-0.2V893c0-0.1,0-0.1,0-0.2c0.1-2,1.9-3.6,4-3.6 h86.6C1220.1,894.3,1223.3,901.3,1230.8,906.5C1230.8,906.5,1230.8,906.5,1230.8,906.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1296.8,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1289.7,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1281.2,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268.2,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254.4,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.3,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1213.5,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1195.8,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.6,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1312.3,
    y: 889.3,
    className: "st4",
    width: 2.1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1317.7,889.3v17.1c-0.3,0-0.5,0.1-0.8,0.1h-1.3v-17.2h1.3C1317.2,889.3,1317.4,889.3,1317.7,889.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1320.6,890.9v13.9c-0.5,0.6-1.2,1.1-2.1,1.4v-16.7C1319.4,889.8,1320.1,890.3,1320.6,890.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1262.9,791.2c0,0-9.7,13.6-18.6,13.8c-8.9,0.2-22.4-6.3-22.4-6.3s-8.1-18.2-2.6-25.3 c0,0,5.5-2.4,11.3,1.9c1,0.7,2,1.7,3,2.9c1.4,1.7,3,2.7,4.7,3.2c6.3,1.9,13.9-2.6,16.7,1.8c1.6,2.5,3.4,4.5,4.9,5.8 C1261.7,790.5,1262.9,791.2,1262.9,791.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1136.7,889.5c0,0,34.2-82.9,95.8-84.5c0,0,56.9,6.3,60,84.5H1136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1215.7,807.6c0,0,24.7,5.5,32.3,2.3c0,0,1.2-10.3-9.2-8.9c-7.1,1-11.8-2.4-14.5-3.8 C1220.4,795.2,1214.6,803.3,1215.7,807.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1237.1,792c-1.6,1.2-6.4-16.7-6.4-16.7c1,0.7,2,1.7,3,2.9c1.4,1.7,3,2.7,4.7,3.2 C1238.4,781.9,1238.7,790.9,1237.1,792z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1259.9,788.9c-0.3,0.2-11.8,7-13.3,7c-1.6,0,8.4-12.8,8.4-12.8C1256.7,785.7,1258.5,787.6,1259.9,788.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1170.1,866.4c-0.6-0.5,24.2-36.6,31.1-36.9c6.8-0.3,22.2,7.9,33.4,8.9c11.1,1.1,21.9-2.1,24,4.5 c2.1,6.6,7.9,29.9,4.3,33.6C1259.4,880.3,1183.8,878,1170.1,866.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1193.5,991.5c0,0,0,0.1,0,0.1c-0.3,5.8-1.2,11.5-2.8,17.1c0,0,0,0,0,0c-0.2,0.8-0.4,1.6-0.7,2.4 c-1.5,5.1-3.6,10-6.1,14.8c-3.1,6-7,11.6-11.6,16.8c-0.1,0.1-0.2,0.3-0.4,0.4c-5.7,6.4-12.5,12.1-20.3,16.8c-1.6,1-3.3,1.9-5,2.8 c-1.2,0.6-2.3,1.2-3.5,1.7c-1.1,0.7-2.3,1.2-3.4,1.9c-3.2,2-7.3,3.6-11.7,4.8v-7.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4 c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h-19.7c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4 c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h7.7 c-1.1-0.5-1.9-1.5-2.1-2.7c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4 c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h4.4c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4v-10.1 c0.1-1.8,1.6-3.3,3.5-3.5h-13.1c-2.1,0-3.9-1.6-4-3.6c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2 c0.2-1.6,1.4-2.9,3.1-3.3c-1.8-0.2-3.2-1.5-3.5-3.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8h7.7c-1.1-0.5-1.9-1.5-2.1-2.7c0-0.1,0-0.2,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0.1-0.3,0.1-0.4c0.5-1.6,2-2.8,3.8-2.8 h15.1c-1.8,0-3.4-1.2-3.8-2.8c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2v-9.7c0-0.1,0-0.1,0-0.2 c0.1-1.8,1.6-3.3,3.5-3.5h-23.7c-1.4,0-2.6-0.7-3.3-1.7l0-0.1l2.5-15.3l0-0.1l3.6-21.8c4.1,0.6,8.2,1.4,12.2,2.5 c0.2,0.1,0.5,0.1,0.7,0.2c0,0,0,0,0,0c2.3,0.7,4.6,1.4,6.9,2.2c0,0,0,0,0.1,0c10.4,3.8,20.2,9.5,28.6,16.8 c0.1,0.1,0.3,0.3,0.4,0.4c4.4,3.9,8.4,8.2,12,12.9c0.7,0.9,1.4,1.9,2.1,2.9c0.2,0.3,0.4,0.6,0.7,1c0,0,0,0,0,0 c1.1,1.6,2.1,3.3,3.1,4.9c2.3,4,4.2,8.1,5.8,12.2c2.1,5.5,3.6,11.1,4.5,16.8c0,0.1,0,0.3,0.1,0.4 C1193.6,980.4,1193.8,986,1193.5,991.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1003.1,1026.4c-24.2-43.9-8.2-99,35.6-123.2c43.9-24.2,99-8.2,123.2,35.6c24.2,43.8,8.2,99-35.6,123.2 C1082.5,1086.2,1027.3,1070.3,1003.1,1026.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1122.8,1063.9c-1.1,0.7-2.3,1.3-3.4,2c-0.4,0.2-0.8,0.4-1.2,0.6c-0.9,0.5-1.8,0.9-2.7,1.4 c-43.2,21.2-95.8,4.9-119.3-37.6c-22.4-40.6-10.4-90.9,26.4-117.3c2.9-2.1,6-4.1,9.3-5.8c1.2-0.6,2.3-1.3,3.5-1.8 c1.1-0.6,2.3-1.1,3.5-1.6c3.5-1.6,7.2-2.9,10.8-4c5.4-1.6,10.9-2.7,16.4-3.3c17.1-1.8,34.3,1.3,49.5,8.8 c16.2,7.9,30.1,20.7,39.5,37.6C1178.6,985.4,1164.1,1038.8,1122.8,1063.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1076.3,1068.7c-7.6,0-15.2-1.1-22.7-3.2c-20.8-6-38.1-19.8-48.6-38.8c-10.5-19-12.9-40.9-6.9-61.8 c6-20.8,19.8-38.1,38.8-48.6c39.2-21.6,88.7-7.3,110.4,31.9c21.6,39.2,7.3,88.7-31.9,110.4 C1103.2,1065.3,1089.8,1068.7,1076.3,1068.7z M1076,908.4c-12.9,0-26,3.2-38,9.8c-18.5,10.2-31.9,27-37.8,47.3 c-5.9,20.3-3.5,41.6,6.7,60.1c10.2,18.5,27,31.9,47.3,37.8c20.3,5.9,41.6,3.5,60.1-6.7c38.2-21,52.1-69.2,31.1-107.4 C1131,923.1,1103.9,908.4,1076,908.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1116.1,995.3c-0.2-0.4-0.4-0.9-0.6-1.3c-1.5-3.2-3.3-5.9-5.5-7.9c-2.5-2.3-5.4-4-8.7-5.1 c-3.3-1.1-7-1.8-11-2.1c-4-0.2-8.5-0.3-13.2-0.2c-2.9,0.1-5.5,0-7.5-0.2c-2.1-0.2-3.9-0.6-5.3-1.2c-1.5-0.6-2.6-1.4-3.5-2.4 c-0.9-1-1.7-2.3-2.3-3.7c-0.6-1.5-0.9-2.9-1-4.4c-0.1-1.4,0.1-2.8,0.6-4.1c0.5-1.3,1.4-2.5,2.5-3.6c1.2-1.1,2.7-2,4.6-2.8 c3.5-1.4,6.8-1.4,9.9,0.1c3.1,1.5,5.6,4.6,7.5,9.4l18.5-7.5c-1.6-4-3.6-7.3-6-10c-2.4-2.7-5.1-4.8-8.2-6.3 c-3-1.5-6.3-2.4-9.9-2.6c-3.6-0.3-7.3,0.1-11.1,1.1l-5.2-12.9l-10.2,4.2l5.2,12.7c-3.7,1.9-6.8,4.1-9.4,6.7 c-2.6,2.5-4.5,5.3-5.9,8.2c-1.4,3-2.1,6.1-2.2,9.3c-0.1,3.3,0.6,6.6,1.9,9.9c1.6,3.9,3.6,7,6.1,9.2c2.5,2.3,5.4,4,8.6,5.1 c3.3,1.1,6.9,1.8,11,2c4.1,0.2,8.5,0.2,13.2,0c2.8-0.2,5.2-0.1,7.2,0c2,0.2,3.8,0.6,5.3,1.2c1.5,0.6,2.7,1.4,3.7,2.5 c1,1.1,1.8,2.4,2.5,4.1c0.6,1.5,0.9,2.9,0.9,4.4c0,1.5-0.3,2.8-1,4.2c-0.7,1.3-1.6,2.6-2.9,3.7c-1.3,1.1-3,2.1-5,2.9 c-1.7,0.7-3.6,1.2-5.4,1.4c-1.9,0.2-3.7,0-5.5-0.5c-1.8-0.6-3.4-1.7-5-3.2c-1.6-1.6-2.9-3.7-4-6.6l-18.5,7.5 c1.9,4.7,4.3,8.5,7.3,11.3c2.9,2.8,6.1,4.8,9.6,6c3.5,1.2,7.1,1.7,10.9,1.6c3.8-0.2,7.5-0.8,11.2-1.9l4.8,11.8l10.2-4.1 l-4.8-11.8c3.7-1.9,6.9-4.1,9.5-6.6c2.4-2.3,4.3-4.8,5.7-7.5c0.1-0.2,0.2-0.4,0.3-0.7c1.4-2.9,2.1-6,2.2-9.3 C1118.2,1002.1,1117.5,998.8,1116.1,995.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1723.3,977c0,0,17.4-20.3,1.1-33.2c0,0-11.9-7.2-21.7-6.6c0,0,13.8,23.1,9.3,25.4 c-4.5,2.3-13.5-26.9-13.5-26.9s-27.2-2.6-35.9,1.6c0,0,23.2,19,18.3,20.1c-4.9,1.1-30-17.5-30-17.5s-25.3,4.3-23.9,19.7 c1.3,15.4,10.1,20.2,13.9,19.8c3.8-0.4,26.2-9,26.7-5.8c0.5,3.1-13,13.4-22.4,13.9c0,0,17.8,19.7,29.7,14 c11.9-5.7,12.9-14.7,20.2-18c7.4-3.4,13.7-3.4,10.6,0.1c-3,3.4-16.4,6.8-20.6,14.3c-4.2,7.5-8,12.5,4.2,10.7 c12.3-1.8,32.2-10.8,33.1-21.1C1723.3,977,1723.3,977,1723.3,977z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1639.4,960c0,0,68.7-2.6,83.9,17c0,0,3.4,10,13.7,19.2l1.6,4.4c0,0-11.9-12.6-16.2-13.3 C1722.4,987.3,1729.1,962.9,1639.4,960z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1737,996.2c0,0,14.7,10.9,15.8,30.4l-2.7,0.2c0,0-4.7-20.1-13.2-28C1728.3,990.9,1737,996.2,1737,996.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1777,960.4c0,0-24.4-13.7-13-32.2c0,0,9.1-11.4,18.9-14.3c0,0-5.2,27.7,0,28.3c5.2,0.7,3.6-31.3,3.6-31.3 s25.7-12.4,35.8-11.4c0,0-16,27-10.7,26.4c5.2-0.7,23.1-28,23.1-28s26.4-4.9,30.6,10.7c4.2,15.6-2.6,23.5-6.5,24.4 c-3.9,1-29,0.7-28.3,3.9c0.7,3.3,17.6,8.5,27,5.5c0,0-10.4,25.7-24.1,24.4c-13.7-1.3-17.9-9.8-26.4-10.4 c-8.5-0.7-14.7,1.6-10.4,3.9c4.2,2.3,18.6,0.7,25.4,6.6c6.8,5.8,12.4,9.4-0.3,12c-12.7,2.6-35.5,1-40.1-8.8 C1777,960.4,1777,960.4,1777,960.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1853.2,913.4c0,0-68.4,22.2-76.2,46.9c0,0,0.3,11.1-6.5,23.8v4.9c0,0,7.2-16.6,11.1-18.9 C1781.6,970.1,1766.3,948.6,1853.2,913.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1770.5,984.1c0,0-10.5,16-4.5,35.5l2.7-0.7c0,0-2.6-21.5,2.9-32.3 C1777.1,975.8,1770.5,984.1,1770.5,984.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1740.1,930c0,0,36.5-20.5,19.5-48.2c0,0-13.6-17-28.3-21.4c0,0,7.8,41.4,0,42.4c-7.8,1-5.4-46.8-5.4-46.8 s-38.5-18.5-53.6-17c0,0,23.9,40.4,16.1,39.5s-34.6-41.9-34.6-41.9s-39.5-7.3-45.8,16.1c-6.3,23.4,3.9,35.1,9.7,36.5 c5.8,1.5,43.4,1,42.4,5.8c-1,4.9-26.3,12.7-40.4,8.3c0,0,15.6,38.5,36,36.5c20.5-1.9,26.8-14.6,39.5-15.6 c12.7-1,21.9,2.4,15.6,5.8c-6.3,3.4-27.8,1.1-38,9.8c-10.2,8.7-18.5,14.1,0.5,18c19,3.9,53.1,1.5,59.9-13.2 C1740.1,930,1740.1,930,1740.1,930z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1626.1,859.9c0,0,102.3,33.1,114,70.1c0,0-0.5,16.6,9.7,35.6v7.3c0,0-10.7-24.8-16.6-28.3 C1733.3,944.6,1756.2,912.5,1626.1,859.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1749.8,965.6c0,0,15.8,24,6.8,53.1l-4.1-1.1c0,0,3.9-32.1-4.3-48.3C1740,953.2,1749.8,965.6,1749.8,965.6 z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1739.2,1075.4c-34.8,0-63.1-28.2-63.1-63.1h126.2C1802.3,1047.2,1774.1,1075.4,1739.2,1075.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.7,
    y: 1012.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3479.0806 2026.5648)",
    className: "st17",
    width: 129.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1766.2,1075.4h-59.1l0,0c0-2.8,2.3-5.1,5.1-5.1h48.9C1763.9,1070.3,1766.2,1072.6,1766.2,1075.4 L1766.2,1075.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1354.7,651.8c-81.2,66.1-178.4,116.9-289,151c-89.9,27.7-189.4,44.7-295.9,50.4c-29,1.6-57.3,2.3-84.6,2.3 c-55.1,0-105.8-2.8-150.1-6.7l17.9-84.7c61,5,133.9,7.6,212.6,3.3c100.2-5.4,193.6-21.3,277.4-47.1 c100.9-31.1,189.1-77.1,262.3-136.6L1354.7,651.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M749.5,483c-11.3-5.9-20.3-2.2-20.3-2.2c-34.5-4.1-44.6,36.2-44.1,50.1c0.5,13.9,2,28.7-13.4,46.7 c-44.6,52,48.8,54.3,48.8,54.3c0.8-41.6,50.6-26.4,48.4-22.2C832.7,625.1,775.2,496.3,749.5,483z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M616.3,656.2c0,0-6.1-9.2-11-9.4c-4.9-0.2-14-2.7-13.2-0.9c0.7,1.8,6.3,2,6.9,3.1c0.5,1.1-8.3,2.7-10.9,2.9 c-2.5,0.2-8.5,0-8.3,1.3c0.2,1.3,10.8,6.5,18.3,5.8c7.5-0.7,16.7,2.2,16.7,2.2L616.3,656.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M704.1,659.2c0,0-3.3,6.5-9.3,14c-7.2,9-18.3,19.5-32.3,21.5c-6.7,1-13.2-0.5-19.2-3.1c0,0,0,0,0,0 c-17-7.5-29.7-24.9-29.7-24.9c-3-8.2,1.9-13.7,1.9-13.7s34.3,7.7,37.5,6.1c3.3-1.6,22.3-56.5,26.8-63.4c4.5-6.9,20-10.5,20-10.5 L704.1,659.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M694.8,673.2c-7.2,9-18.3,19.5-32.3,21.5c-6.7,1-13.2-0.5-19.2-3.1c0.7,0.1,17.6,2.2,24.4-9.9 c6.9-12.3,14.3-31.9,24.6-25.4C696.7,659.2,696.5,666.2,694.8,673.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M831.9,1029c0,0,10.5,9.5,8.4,16.3c-2,6.8-11.5,11.3-12.7,19.6c-1.3,8.3-6.4,12.8-11,12.8 c-4.6,0-21.9,0-21.9,0s-3.4-5.8,4.8-7.6c8.2-1.8,11.2-11.5,10.7-20.5c-0.5-9,0.8-21.1,0.8-21.1l17.3-4L831.9,1029z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M743.4,1033.1c0,0,3.8,40.4-0.8,42.7l-58.7-0.1c0,0,0-6.8,9.4-8.3c9.4-1.5,26-7,28.8-19.3 C724.9,1035.7,743.4,1033.1,743.4,1033.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M785.3,743.1c-12.1-27.1-19.5-34.9-18.1-43.3c1.1-6.3-3.2-116.8-3.2-116.8c-1.4-0.4-4.3-0.8-5.9-1.2 c-5-1.1-9.1-4.6-10.8-9.4c-2.1-5.8-3.7-14.3-3.7-24.9l-1.5,0.3l-26,5.2c0,0,0.6,8.2,0.6,15.9c0,0.1,0,0.1,0,0.2 c0,6.7-4.4,12.6-10.8,14.5c-3.3,0.9-6.1,1.8-6.1,1.8s-9.6,27.3-11.4,55.3c-1.8,28,17.4,40.2-0.1,96.3 C670.4,794.2,792,758.1,785.3,743.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M716.1,553c0,0,0.6,8.2,0.6,15.9c14.6-0.4,22.3-13.7,25.4-21.1L716.1,553z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M711.3,560.3c0,0,34.5,0.6,34.5-20.9c0-21.5,4.5-35.9-17.5-37.1c-22-1.3-26.3,6.9-28,14.1 C698.5,523.5,702.3,559.6,711.3,560.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M712.6,501.7c0,0,9.4,25.2,23.9,28.9c14.5,3.7,20.8-0.2,20.8-0.2s-11.1-8.8-13.4-24.2 C743.8,506.3,719.7,489.8,712.6,501.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M714.9,503.8c0,0-7,2.6-9.9,7.7c-2.8,5-5.2,11.6-4.7,19.7c0,0-7.1-17.1,0.9-26.8 C709.7,494.1,714.9,503.8,714.9,503.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M718.8,547c0,0-2.4,3.1-7.1,2.9c-3.8-0.2-5.3-3.5-5.3-3.5S713.4,544.7,718.8,547z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M788.6,631.9c0,0,0.9,12.3,0,27.2c-0.6,9.8-10.5,23-11.9,26.2c-3.5,8.2-7.5,9.5-7.5,9.5l-30.8,7.6l-10.8,2.7 l-34.2-10.2c0,0-15.6-43.5-9.3-68c6.3-24.5,15.8-41.5,15.8-41.5s27.9,27.3,64.2-2.3L788.6,631.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M695.5,701.4c0,0-16.9,52.7-18,70.7c-1.1,17.9,32.4,255,33.7,263.2c1.3,7.8,10.9,12.8,10.9,12.8 s4.5,2.6,10.8,0.8c8.8-2.5,11.6-5.5,11.6-5.5s13.2-169,5-229.4c-8.2-60.4-8.3-112.6-8.3-112.6H695.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M767.2,699.8c0,0,25.8,34.7,28.2,58.1c2.4,23.4,3.8,105.7,8.9,128.6c5.1,22.8,24,66.8,24,138.1 c0,0-2,4.1-8,6.3c-1.9,0.7-4.5,1.4-7,1.9c-5,1.1-10.1-1.3-12.4-5.9c-12.7-25.7-53.3-108.4-55.4-125.6 c-1.5-12.2-14.3-92.6-42.3-139.8c-6.7-11.3,4.1-56.4,4.1-56.4L767.2,699.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M718,547.6c0,0-0.6,2.5-6.9,2.1c0,0-5.3-0.3-5.1-3.1C706,546.6,711.1,544.6,718,547.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M692.8,693.2c0,0,6.8,5.4,20.3,5.7c16.1,0.3,56.1-4.1,56.1-4.1s1.8,5,1.7,10.2c0,0-48.8,12.3-77.1,1.8 C693.8,706.8,690.1,699.9,692.8,693.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M709.2,712.8c-4.1,0-7.4-3.7-7.4-8.3c0-4.6,3.3-8.3,7.4-8.3c4.1,0,7.4,3.7,7.4,8.3 C716.6,709,713.3,712.8,709.2,712.8z M709.2,698.6c-2.7,0-4.9,2.6-4.9,5.9c0,3.2,2.2,5.9,4.9,5.9c2.7,0,4.9-2.6,4.9-5.9 C714.1,701.2,711.9,698.6,709.2,698.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 733.8,
    y: 644.9,
    transform: "matrix(0.7542 -0.6567 0.6567 0.7542 -264.7783 673.3486)",
    className: "st2",
    width: 66.3,
    height: 90.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M757.9,702.9c0,0-18.3,2.1-18.3,6.5c0.1,4.4,4.6,13.3,6.8,13.7c2.3,0.4,14.9-12.1,14.9-12.1L757.9,702.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M764,583c0,0,24.5,1.7,33.9,24.5c9.4,22.8,27.2,61.1,27.2,67.5c0,6.4-9.9,26.3-63.3,37.7 c0,0-5.5-5.8-5.2-10.4c0,0,33.3-28.6,33.2-32c-0.2-6.3-5.5-14.7-34.7-44C747.1,618.5,764,583,764,583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M234.7,1077.7h-0.2c-1.4,0-2.6-1.2-2.5-2.6l3.8-166.8l11.3-1.3l-9.7,168.1 C237.4,1076.6,236.2,1077.7,234.7,1077.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M417,1077.7h0.2c1.4,0,2.6-1.2,2.5-2.6l-3.8-166.8l-11.3-1.3l9.7,168.1 C414.3,1076.6,415.5,1077.7,417,1077.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M227.2,898V783.7c0-20.1,16.3-36.4,36.4-36.4H346c20.1,0,36.4,16.3,36.4,36.4v118.7L227.2,898z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M397.1,916H237.8c-5.9,0-10.6-4.8-10.6-10.6V898h169.9V916z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M418.9,916H293.1c-2.9,0-5.3-2.4-5.3-5.3v-7.4c0-2.9,2.4-5.3,5.3-5.3h125.8c2.9,0,5.3,2.4,5.3,5.3v7.4 C424.3,913.6,421.9,916,418.9,916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M411.5,869.5C399.7,890,384.9,898,384.9,898h-61.7C323.1,898,420.5,853.8,411.5,869.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M364.1,1028.4c-1.6,1.8-1.8,3.9-1,6.1c0,0,0,0,0,0c1.5,4.1,6.3,8.6,12,13.1c0.7,0.6,1.4,1.1,1.9,1.6 c0.1,0.1,0.3,0.3,0.4,0.4c0.1,0.1,0.2,0.2,0.3,0.3c5.3,4.9,3.3,6,12.7,15.8c10.8,11.2,18.2,11.4,20.3,10.4 c1.8-0.9-1.8-6.8-5.9-13.5c-0.2-0.3-0.4-0.6-0.6-1c-0.5-0.9-1.1-1.8-1.6-2.7c-4.7-8.1-3.5-11.8-2.4-23.8 c0.9-9.7,15.2-54.4,15.2-54.4l-20.7-3.6c0,0-6.2,35.6-13.1,41.1c-3.7,2.9-7.8,3-11.3,5.1c-0.2,0.2-0.5,0.3-0.7,0.5 C367.8,1025.1,365.7,1026.5,364.1,1028.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M364.1,1028.4c-1.6,1.8-1.8,3.9-1,6.1c0,0,0,0,0,0c1.8,4.1,6.5,8.6,12,13.1c0.7,0.6,1.3,1.1,1.9,1.6 c0.1,0.1,0.3,0.3,0.4,0.4c0.1,0.1,0.2,0.2,0.3,0.3c5.3,4.9,3.3,6,12.7,15.8c10.8,11.2,18.2,11.4,20.3,10.4 c1.8-0.9-1.8-6.8-5.9-13.5c-2.1-0.8-11.9-4.7-19.2-14.2c-6.5-8.3-10.8-18.9-15.3-25.1c-0.2,0.2-0.5,0.3-0.7,0.5 C367.8,1025.1,365.7,1026.5,364.1,1028.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M530.9,1015.4c1.3,6.4,10.4,5.3,20.5,2.8c10.2-2.5,7.8,0.5,22.2-1.1c14.5-1.6,18.9-7,19.3-9.1 c0.4-1.9-6.8-2.6-14.4-3.5c-1-0.1-1.9-0.2-2.9-0.3c-8.7-1.1-15-6.7-22.9-11.3c-7.4-4.3-18.6-22.1-18.6-22.1l-19.8,1.6 c0,0,10.4,15.8,14.4,22.7c2.4,4,2.2,9.4,1.9,13.5C530.6,1010.9,530.4,1013.2,530.9,1015.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M551.4,1018.3c10.2-2.5,7.8,0.5,22.2-1.1c14.5-1.6,18.9-7,19.3-9.1c0.4-1.9-6.8-2.6-14.4-3.5l-0.1,0.1 c0,0-8.7,6.2-20.7,6.4c-9.8,0.2-20.2-2.6-27-2.5c-0.2,2.2-0.3,4.5,0.2,6.8C532.1,1021.8,541.2,1020.8,551.4,1018.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M454.8,888.6l-18.6,49.9l-24.2,65.2c0,0-6.6,0.6-12.9-1.2c-5.8-1.7-12.4-6.1-12.4-6.1s6.7-70,19.3-110.2 c3.2-10.3,6.8-18.7,10.8-23.3C436.2,839.9,454.8,888.6,454.8,888.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M436,809.3c-12.2-3.9-46.8,1.1-81.6,7.9l-7.3-12l-75.2-5.9c0,0-24.8,55-11.2,90.1c2,5.2,6,8.5,12.7,8.6 c0,0,1.1,0,1.1,0c0,0,44.8,0,59.3,0c37.4,0,79.2-25.7,84.6-26.8c8.8-1.8,12.4,15.9,21.2,34.5c8.8,18.6,83.1,82.2,83.1,82.2 s11.4,0.1,16.1-1.7c5.1-1.9,6.9-4.4,6.9-4.4S463.4,818.1,436,809.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M344.1,586.2c-9.6-5.1-24.3-5.7-26.7-6.1c-28.5-3.8-45.7,37.6-46.7,50.1c-1.9,23.1-14.1,26.7-31.3,41.1 c-34.5,29-24.4,62.8-5.5,75.3c11.3,7.5,31.3,0,31.3,0c0.3,0.2,54.6-30.4,81.4-45.1C386.7,695.9,368.6,599.1,344.1,586.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M324.1,689.1c0.1,0.1-13.2,4.6-22.1,0.7c-8.4-3.7-14.7-17.5-14.6-17.5c3.8-0.2,8-3.5,11.2-25.3l1.6,0.6 l27.2,9.8c0,0-2,8.7-3.3,17.1C323.2,681.4,322.7,688.1,324.1,689.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M327.6,657.3c0,0-2,8.7-3.3,17.1c-15.6-2.8-21.8-18.4-24-26.9L327.6,657.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M331.6,666c0,0-37.3-5-33.8-28.2c3.5-23.2,1-39.4,24.9-37.2c23.9,2.2,27.2,11.7,27.9,19.8 C351.4,628.4,341.4,666.7,331.6,666z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M349.4,607.7c0,0-23.9,20.6-40.1,22.2c-16.2,1.7-22.4-3.6-22.4-3.6s9.6-7.9,15.3-20.8 c1.7-3.8,5.3-6.4,9.4-6.7C323.2,597.9,345.2,597.4,349.4,607.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M334.4,605.9c0,0,8,7.7,10.5,13.4c2.4,5.5,3.2,18.7,1.2,24c0,0,12.4-24.2,5.4-35.9 C344.1,594.9,334.4,605.9,334.4,605.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.5,744c-1.1,75.4-0.3,59.7-8.6,66.8c-2,1.7-7.6,2.8-14.9,3.2c-23.1,1.5-63.8-2.3-65.3-6.6 c-5.3-14.8-1.6-19.4-6-42c-0.5-2.4-1-5-1.7-7.9c-3.7-15.6-7.3-20.8,5.8-45.8c11.9-22.6,24.3-41,25.5-40.3c31.5,18.7,34,3,34,3 S356.1,707.2,355.5,744z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M436.3,938.5l-24.2,65.2c0,0-6.6,0.6-12.9-1.2c-5.8-1.7-12.4-6.1-12.4-6.1s6.7-70,19.3-110.2L436.3,938.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.3,674.4c0,0,32.4,5.5,36.2,19.5c3.8,14,26.2,96,26.2,96s-16.5,3-24.1-4.7 c-7.6-7.6-26.5-70.6-26.5-70.6L324.3,674.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332,814c-23.1,1.5-63.8-2.3-65.3-6.6c-5.3-14.8-1.6-19.4-6-42l11.2-31.4c0,0-1.8,35,8.5,44.2 c10.3,9.2,42.2,17.8,47.3,25.5C330,807.4,331.6,811.1,332,814z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M305.5,799.3c0,0,22.8-5.1,26.5-3.1c3.7,2,12.7,9.4,13.8,12c1.1,2.6-8.2-1.9-11.2-2.8 c-2-0.5-7.1,1.3-9.7,2.1c-10.8,3.6-17.4,1.7-17.4,1.7L305.5,799.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.2,671.4c0,0-30.6,1.9-41.2,16.7c-14.9,20.8-44.6,109.6-27.6,121.4c19.1,13.3,87,3.5,87,3.5 s2.3-10.6-0.9-15.7c-3.1-5.1-54.2-13.4-56.6-15.7c-2.4-2.4,29.5-46,29.5-53C280.4,721.5,290.2,671.4,290.2,671.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M333.1,802.6c0,0,4.8,6.2,6.3,6.9c1.6,0.7,2.6,0.6,2.6,0.6l-3.2-5.8L333.1,802.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332,796.3l13.9,6.8c0,0-0.6,1-2.3,0.9c-1.7-0.1-6-1.7-6-1.7L332,796.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "334.5,819 451.7,819 487,736.7 369.9,736.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "453.1,813.6 298.2,813.6 298.2,818.8 451.7,818.8  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M422.1,777.8c0.9-2.9-0.9-5.2-4-5.2c-3.1,0-6.3,2.3-7.2,5.2c-0.9,2.9,0.9,5.2,4,5.2 C418,783.1,421.2,780.7,422.1,777.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M625.2,1080h0.3c1.9,0,3.4-1.7,3.4-3.8l-5.1-243.4l-15-1.9l12.8,245.3C621.6,1078.3,623.2,1080,625.2,1080 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M309.2,1080h-0.3c-1.9,0-3.4-1.7-3.4-3.8l5.1-243.4l15-1.9l-12.8,245.3 C312.7,1078.3,311.1,1080,309.2,1080z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M631.4,836.4H289.3c-2.8,0-5.1-2.3-5.1-5.1v-7.2c0-2.8,2.3-5.1,5.1-5.1h342.1c2.8,0,5.1,2.3,5.1,5.1v7.2 C636.5,834.1,634.2,836.4,631.4,836.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveUpBg00);
export default __webpack_public_path__ + "static/media/move_up_bg00.7fdb9590c5289284cd077989730b405f.svg";
export { ForwardRef as ReactComponent };